import produce from 'immer';

import { SET_SNACKBAR } from './actionTypes';

export const initialState = {
  snackbar: {},
};

/* eslint-disable default-case */

const snackbarReducer = (state = initialState, { type, payload }) =>
  produce(state, (draft) => {
    switch (type) {
      case SET_SNACKBAR:
        draft.snackbar = payload;
        break;
    }
  });

export default snackbarReducer;
